import { render, staticRenderFns } from "./PracticalExamStudents.vue?vue&type=template&id=4d878fe4&"
import script from "./PracticalExamStudents.vue?vue&type=script&lang=ts&"
export * from "./PracticalExamStudents.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports